// Date helpers using America/Sao_Paulo (Brasília) timezone.
// Prevents entries near midnight from being registered on the wrong day
// when the user's device is in UTC or another zone.

const TZ = "America/Sao_Paulo";

/** Returns "YYYY-MM-DD" for the current Brasília date. */
export function todayBR() {
  // sv-SE locale outputs ISO-like "YYYY-MM-DD"
  return new Date().toLocaleDateString("sv-SE", { timeZone: TZ });
}

/** Converts any Date object to "YYYY-MM-DD" in Brasília timezone. */
export function toBRDate(d) {
  return new Date(d).toLocaleDateString("sv-SE", { timeZone: TZ });
}
